export const SortOrder = Object.freeze({
    ASC: Symbol("ASC"),
    DESC: Symbol("DESC")
})